import React, { createContext, useContext, useState } from "react";

const PaymentModeContext = createContext();

export function PaymentModeProvider({ children }) {
  const [mode, setMode] = useState("live"); // default

  return (
    <PaymentModeContext.Provider value={{ mode, setMode }}>
      {children}
    </PaymentModeContext.Provider>
  );
}

export function usePaymentMode() {
  return useContext(PaymentModeContext);
}